(function ($, Drupal) {

  Drupal.behaviors.carousel_full_width_fluid = {
    attach: function (context, settings) {

    // Set all carousel items to the same height
    function carouselNormalization() {

    window.heights = [], //create empty array to store height values
    window.tallest = 0; //create variable to make note of the tallest slide

    function normalizeHeights() {
        jQuery('.carousel-content-desktop .carousel .carousel-inner .carousel-item').each(function() { //add heights to array
          window.heights.push(jQuery(this).outerHeight());
        });

        window.tallest = Math.max.apply(null, window.heights); //cache largest value

        jQuery('.carousel-content-desktop .carousel .carousel-inner .carousel-item').each(function() {
          jQuery(this).css('min-height',tallest + 'px');
        });
      }

    normalizeHeights();

    jQuery(window).on('resize orientationchange', function () {
      window.tallest = 0, window.heights.length = 0; //reset vars

    jQuery('.carousel-content-desktop .carousel .carousel-inner .carousel-item').each(function() {
      jQuery(this).css('min-height','0'); //reset min-height
    });

    normalizeHeights(); //run it again

  });

  window.heights.push(jQuery(this).outerHeight());
}

if ($('.carousel-content-desktop').length >= 1) {
    $('.carousel-content-desktop').each(function() {
      $(this).find('.carousel-inner+.row .carousel-indicators').insertAfter($(this).find('.carousel-inner+.row'));
    });
    // Content Carousel
    carouselNormalization();
}

$(window).on('load', function() {

        $('.cards-carousel-fluid').each(function () {
          $(this).mouseenter(function() {
            $(this).addClass('active-card');
          }).mouseleave(function() {
            $(this).removeClass('active-card');
           });
        });

        $(".full-scroll").on("scroll", function () {
          var cur = $(this).scrollLeft();
          if (cur == 0) {
            $('.l-scroll').attr("disabled","disabled")
          }
          else {
            var max = $(this)[0].scrollWidth - $(this).parent().width();
            if (cur == max) {
              $('.active-card .r-scroll').attr("disabled","disabled");
              $('.active-card .l-scroll').removeAttr("disabled","");
            }
            else {
              $('.active-card .l-scroll').removeAttr("disabled","");
              $('.active-card .r-scroll').removeAttr("disabled","");
            }
          }
        });

        var card_width = parseInt($('.cards-carousel-fluid .carousel-items').first().css('width'))+parseInt($('.cards-carousel-fluid .carousel-items').first().css('margin-right'))+parseInt($('.cards-carousel-fluid .carousel-items').first().css('margin-left'))+parseInt($('.cards-carousel-fluid .carousel-items').first().css('padding-left'))+parseInt($('.cards-carousel-fluid .carousel-items').first().css('padding-right'));
          $('.cards-carousel-fluid .l-scroll').click(function() {
            $('.cards-carousel-fluid.active-card .full-scroll').animate({
              scrollLeft: '-='+card_width
            }, "500");
        });
        $('.cards-carousel-fluid .r-scroll').click(function() {
          $('.cards-carousel-fluid.active-card .full-scroll').animate({
            scrollLeft: '+='+card_width
          }, "500");
        });
      });
    }
  };
})(jQuery, Drupal);